import { createFileRoute, Outlet } from "@tanstack/react-router"

import { findOrderedStepByNameAndSessionId } from "@/services/dexie"

export const Route = createFileRoute("/$sessionId/_session/damage")({
  // As there is only 1 damage step, the enableUpload flag is pre-loaded on route level and passed down to child routes via route context.
  loader: async ({ params }) => {
    const step = await findOrderedStepByNameAndSessionId("Damage", params.sessionId)

    return { enableUpload: step?.enableUpload === true }
  },
  component: () => <Outlet />,
})
